function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage } from 'react-intl';
import Modal from 'components/Modal';
import Button from 'components/Form/Button';
import App from 'modules/App';
import * as constants from '../../../constants';
import * as actions from '../../../actions';
import * as selectors from '../../../selectors';
import messages from '../../../messages';
import styles from './EnableCountryModal.pcss';
var _React_PureComponent;
class EnableCountryModal extends (_React_PureComponent = React.PureComponent) {
    componentDidUpdate(prevProps) {
        if (prevProps.isInProgress && !this.props.isInProgress) {
            this.onValidated();
        }
    }
    componentWillUnmount() {
        this.props.onClearResult();
        this.setState({
            isValidated: false
        });
    }
    onValidated() {
        this.setState({
            isValidated: true
        });
    }
    renderDetails(error) {
        return /*#__PURE__*/ _jsxs("li", {
            children: [
                /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.errors.enableCountry[error])),
                " "
            ]
        }, error);
    }
    renderContent() {
        if (!this.state.isValidated) return this.renderToConfirm();
        if (this.props.enableCountryErrors) return this.renderErrors();
        return this.renderSuccess();
    }
    renderToConfirm() {
        const { englishName, code } = this.props.country;
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsx("p", {
                    className: "text--paragraph pr-2 mb-3",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, messages.infos.confirmEnableCountry), {
                        values: {
                            countryName: englishName
                        }
                    }))
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "d-flex",
                    children: [
                        /*#__PURE__*/ _jsx(Button, {
                            type: "button",
                            styleModifier: "primary",
                            labelMessage: App.messages.buttons.cancel,
                            className: "btn--block mr-8",
                            isInProgress: this.props.isInProgress,
                            onClick: ()=>this.props.onClose()
                        }),
                        /*#__PURE__*/ _jsx(Button, {
                            type: "button",
                            styleModifier: "primary",
                            labelMessage: App.messages.buttons.confirm,
                            className: "btn--block btn--filled",
                            isInProgress: this.props.isInProgress,
                            onClick: ()=>this.props.onEnableCountry(code)
                        })
                    ]
                })
            ]
        });
    }
    renderSuccess() {
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "form-success d-flex flex-column pt-7 pb-7 pl-8 pr-8 align-items-center",
                    children: /*#__PURE__*/ _jsx("p", {
                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.enableCountrySuccess))
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "d-flex",
                    children: /*#__PURE__*/ _jsx(Button, {
                        type: "button",
                        styleModifier: "primary",
                        labelMessage: App.messages.buttons.confirm,
                        className: "btn--block btn--filled",
                        isInProgress: this.props.isInProgress,
                        onClick: ()=>this.props.onClose()
                    })
                })
            ]
        });
    }
    renderErrors() {
        const errors = this.props.enableCountryErrors.map((error)=>this.renderDetails(error));
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.enableCountryErrorInfo,
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "form-error d-flex flex-column pt-7 pb-7 pl-8 pr-8 align-items-start",
                    children: [
                        /*#__PURE__*/ _jsx("p", {
                            children: /*#__PURE__*/ _jsx("b", {
                                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.enableCountryFailed))
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            children: errors
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(Button, {
                    type: "button",
                    styleModifier: "primary",
                    labelMessage: App.messages.buttons.ok,
                    className: "btn--block btn--filled",
                    onClick: ()=>this.props.onClose()
                })
            ]
        });
    }
    render() {
        return /*#__PURE__*/ _jsx(Modal, {
            modalId: constants.ENABLE_COUNTRY_MODAL,
            openModalId: this.props.openModalId,
            headerMessage: messages.headers.enableCountryFailed,
            styleModifier: "lg",
            isInProgress: this.props.isInProgress,
            onClose: this.props.onClose,
            children: this.renderContent()
        });
    }
    constructor(props){
        super(props);
        this.state = {
            isValidated: false
        };
    }
}
_define_property(EnableCountryModal, "propTypes", {
    // Explicit props
    country: PropTypes.object,
    // Explicit actions
    // Implicit props
    isInProgress: PropTypes.bool,
    enableCountryErrors: PropTypes.array,
    openModalId: PropTypes.string,
    // Implicit actions
    onClose: PropTypes.func,
    onClearResult: PropTypes.func,
    onEnableCountry: PropTypes.func
});
const mapStateToProps = (state)=>({
        openModalId: App.selectors.modal(state),
        enableCountryErrors: selectors.enableCountryErrors(state),
        isInProgress: selectors.isEnableCountryProgress(state)
    });
const mapDispatchToProps = (dispatch)=>({
        onClose: ()=>dispatch(App.actions.closeModal()),
        onEnableCountry: (countryCode)=>dispatch(actions.enableCountry(countryCode)),
        onClearResult: ()=>dispatch(actions.enableCountryClear())
    });
const ConnectedEnableCountryModal = connect(mapStateToProps, mapDispatchToProps)(EnableCountryModal);
export default withStyles(styles)(ConnectedEnableCountryModal);
